<template>
  <span>
    <a @click.stop
      v-if="billingPriceId"
      :href="priceUrl(billingPriceId)"
      target="_blank"
    >{{ billingPriceId }}</a>
    <span v-if="billingPrice" @click.stop>
      <a
        v-if="billingPrice.id"
        :href="priceUrl(billingPrice.id)"
        target="_blank"
      >{{ billingPrice.id }}</a>
    </span>
  </span>
</template>
<script type="ts">
import Vue from 'vue';
import BillingPrice from '@/datatypes/billing/price';

export default Vue.extend({
  name: 'price-text',
  props: {
    billingPrice: {
      type: BillingPrice,
      default: undefined,
    },
    billingPriceId: {
      type: String,
      default: '',
    },
  },
  methods: {
    priceUrl(priceId) {
      return this.$billingProviderUrl[process.env.VUE_APP_PROVIDER].price(priceId);
    },
  },
});
</script>
